import React from 'react'
import styles from './vrBenefits.module.scss'
import { strings } from '../../../components/utils/translations'

import SecurityIcon from '../../../img/icons/vr_benefits/security.png'
import SecurityIconDark from '../../../img/icons/vr_benefits/security_dark.png'
import ConfortIcon from '../../../img/icons/vr_benefits/confort.png'
import ConfortIconDark from '../../../img/icons/vr_benefits/confort_dark.png'
import EconomicIcon from '../../../img/icons/vr_benefits/economic.png'
import EconomicIconDark from '../../../img/icons/vr_benefits/economic_dark.png'

const BENEFITS =
[
    {
        key: 'security',
        image: SecurityIcon,
        imageDark: SecurityIconDark,
        multiplier: 'x5',
        colorClass: 'accent',
        adjectiveKey: 'safer',
        descriptionKey: 'benefitDescription1'
    },
    {
        key: 'confort',
        image: ConfortIcon,
        imageDark: ConfortIconDark,
        multiplier: 'x10',
        colorClass: 'orange',
        adjectiveKey: 'moreComfortable',
        descriptionKey: 'benefitDescription2'
    },
    {
        key: 'economic',
        image: EconomicIcon,
        imageDark: EconomicIconDark,
        multiplier: 'x4',
        colorClass: 'green',
        adjectiveKey: 'moreEconomic',
        descriptionKey: 'benefitDescription3'
    }
]

const VRBenefits = () =>
{
    return (
        <div className={styles.benefits}>
            <div className={styles.benefitsTitle}>{ strings('yourVRis') }</div>

            <div className={styles.benefitsList}>
                {
                    BENEFITS.map(benefit =>
                        <div key={benefit.key} className={styles.benefit}>
                            <div className={styles.iconContainer}>
                                <img className={styles.icon} src={benefit.image} alt="" />
                                <img className={styles.iconDark} src={benefit.imageDark} alt="" />
                            </div>

                            <div className={styles.benefitText}>
                                <div className={styles.headline}>
                                    <span className={styles[benefit.colorClass]}>
                                        <span className={styles.multiplier}>{ benefit.multiplier }</span>
                                        { ` ${strings('times')} ${strings(benefit.adjectiveKey)}` }
                                    </span>
                                    { ` ${strings('thanYourTraditionalRemote')}` }
                                </div>
                                <div className={styles.description}>
                                    { strings(benefit.descriptionKey) }
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default VRBenefits
